import React from 'react';
import { useNavigate, Routes, Route } from 'react-router-dom';
import { FaUsers } from '@react-icons/all-files/fa/FaUsers';
import { FaIdCard } from '@react-icons/all-files/fa/FaIdCard';
import { FaUserCog } from '@react-icons/all-files/fa/FaUserCog';
import { FaCog } from '@react-icons/all-files/fa/FaCog';
import { FaHome } from '@react-icons/all-files/fa/FaHome';
import Breadcrumb from '../../../commons/Breadcrumb';
import TileContainer, { TileItem } from '../../../commons/TileContainer';
import UsuarioPage         from './usuario/usuario-page';
import UsuarioFormPage     from './usuario/usuario-form-page';

const tiles: TileItem[] = [
  { key: 'perfiles', label: 'Perfiles', icon: <FaIdCard />, color: '#3b82f6' },
  { key: 'usuarios', label: 'Usuarios', icon: <FaUserCog />, color: '#0ea5e9' },
];

function UsuariosIndex() {
  const navigate = useNavigate();

  return (
    <div style={s.page}>
      <Breadcrumb items={[
        { label: 'Inicio',        to: '/',               icon: <FaHome /> },
        { label: 'Configuración', to: '/configuracion',  icon: <FaCog /> },
        { label: 'Usuarios',                             icon: <FaUsers /> },
      ]} />

      <div style={s.header}>
        <div style={{ ...s.iconBox, background: '#0ea5e9' }}>
          <FaUsers style={s.icon} />
        </div>
        <div>
          <h2 style={s.title}>Usuarios</h2>
          <p style={s.subtitle}>Configuración de usuarios</p>
        </div>
      </div>

      <TileContainer
        tiles={tiles}
        onSelect={key => navigate(`/configuracion/usuarios/${key}`)}
      />
    </div>
  );
}

function SubPage({ tileKey }: { tileKey: string }) {
  const tile = tiles.find(t => t.key === tileKey)!;

  return (
    <div style={s.page}>
      <Breadcrumb items={[
        { label: 'Inicio',        to: '/',                          icon: <FaHome /> },
        { label: 'Configuración', to: '/configuracion',             icon: <FaCog /> },
        { label: 'Usuarios',      to: '/configuracion/usuarios',    icon: <FaUsers /> },
        { label: tile.label,                                        icon: tile.icon },
      ]} />

      <div style={s.header}>
        <div style={{ ...s.iconBox, background: tile.color }}>
          <span style={s.icon}>{tile.icon}</span>
        </div>
        <div>
          <h2 style={s.title}>{tile.label}</h2>
          <p style={s.subtitle}>Configuración de {tile.label.toLowerCase()}</p>
        </div>
      </div>

      <div style={s.placeholder}>
        <span style={{ fontSize: 32, color: '#cbd5e1' }}>{tile.icon}</span>
        <p style={{ margin: 0, color: '#94a3b8', fontSize: 14 }}>
          Configuración de <strong>{tile.label}</strong>
        </p>
      </div>
    </div>
  );
}

export default function UsuariosConfigPage() {
  return (
    <Routes>
      <Route path="/"                  element={<UsuariosIndex />} />
      <Route path="/perfiles"              element={<SubPage tileKey="perfiles" />} />
      <Route path="/usuarios"            element={<UsuarioPage />} />
      <Route path="/usuarios/new"        element={<UsuarioFormPage />} />
      <Route path="/usuarios/:id/edit"   element={<UsuarioFormPage />} />
    </Routes>
  );
}

const s: Record<string, React.CSSProperties> = {
  page:        { display: 'flex', flexDirection: 'column', gap: 28 },
  header:      { display: 'flex', alignItems: 'center', gap: 14 },
  iconBox:     { width: 48, height: 48, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  icon:        { fontSize: 22, color: '#fff', display: 'flex' },
  title:       { margin: 0, fontSize: 22, fontWeight: 700, color: '#0f172a' },
  subtitle:    { margin: 0, fontSize: 13, color: '#64748b' },
  placeholder: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12, padding: '48px 24px', background: '#fff', border: '1px dashed #e2e8f0', borderRadius: 12 },
};
